1
<template>
  <div v-if="dataPermission && dataPermission.includes('CNPS_WKCLDR_GET_LIST_TASK_BY_USERID')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Lịch làm việc</h1>
      <div class="float-right btn-group">
        <DraggableTable :naming="$route.name" v-model="fieldTable" @change="filterTable = $event" />
        <button
          @click="$router.push('/calendar/add')"
          v-if="dataPermission.includes('CNPS_WKCLDR_UPSERT_WKCLDR')"
          class="font-medium f12 btn btn-outline-secondary"
        >
          <i class="bx bx-plus-circle"></i> Thêm mới
        </button>
        <button
          @click="$router.push('calendar-import-file')"
          v-if="dataPermission.includes('CNPS_WKCLDR_IMPORT_DATA')"
          class="font-medium f12 btn btn-outline-secondary"
        >
          <i class="bx bx-upload"></i> Nhập excel
        </button>
        <button
          @click="exportExcel"
          v-if="dataPermission.includes('CNPS_WKCLDR_EXPORT_WKCLDR')"
          class="font-medium f12 btn btn-outline-secondary"
        >
          <i class="bx bx-download"></i> Xuất excel
        </button>
      </div>
    </div>
    <div class="p-10 card pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.title"
              class="form-control f12 hc-37"
              placeholder="Tên MC/SĐT/Địa chỉ"
            />
          </div>
          <div class="form-group">
            <DateRangePicker
              :ranges="false"
              class="w-100"
              @update="transfromDate()"
              v-model="dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian tạo
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <DateRangePicker
              :ranges="false"
              class="w-100"
              @update="transformIntendTime()"
              v-model="intendTimeRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian dự kiến
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.regionId"
              :options="dataConfigRegion"
              @change="queryProvince($event)"
              placeholder="Vùng"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.provinceId"
              :options="dataProvince"
              placeholder="Tỉnh/Thành phố"
            />
          </div>
          <div class="form-group">
            <Select2 v-model="search.superiorId" :options="listUser" placeholder="Quản lý" />
          </div>
          <div class="form-group">
            <Select2 v-model="search.saleId" :options="listUser" placeholder="Nhân viên" />
          </div>
          <div class="form-group">
            <Select2 v-model="search.wkType" :options="dataWorkType" placeholder="Loại công việc" />
          </div>
          <div class="form-group">
            <Select2 v-model="search.cat" :options="dataConfigPurposes" placeholder="Mục đích" />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.leadAction"
              :options="dataLeadAction"
              placeholder="Hình thức"
            />
          </div>
          <div class="form-group">
            <Select2 v-model="search.isPeriod" :options="dataPeriod" placeholder="Độ ưu tiên" />
          </div>
          <div class="form-group">
            <Select2 v-model="search.outcome" :options="optionOutcome" placeholder="Trạng thái" />
          </div>
          <div class="form-group form-group-action">
            <button
              @click="submitForm"
              class="pt-2 mr-2 btn btn-primary hc-37"
              type="button"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i>
              <span class="ml-1"></span>Lọc
            </button>
            <button
              @click="clearSearch()"
              class="pt-2 mr-2 btn btn-outline-light hc-37"
              type="button"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
            >
              <i class="bx bx-filter-alt"></i>
              <span class="ml-1"></span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <b>Tổng công việc</b>: {{ totalRows }} &nbsp;| <b>CV Leads</b>:
            {{ totalOther.totalLead }} &nbsp;| <b>CV KH tiềm năng</b>:
            {{ totalOther.totalPotential }} &nbsp;| <b>CV Merchant</b>:
            {{ totalOther.totalMerchant }}
            <b-table
              :busy.sync="loading"
              sticky-header
              hover
              responsive
              :items="dataCalendar"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="my-2 text-center">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(merchant)="data">
                <div v-if="data.item.merchantInforRes">
                  <p>
                    <strong>{{ data.item.merchantInforRes.merchantName }}</strong>
                  </p>
                  <p>{{ data.item.merchantInforRes.mobile | encryptPhone }}</p>
                  <p>{{ data.item.merchantInforRes.email }}</p>
                </div>
                <div v-else-if="data.item.leadInfoRes">
                  <p>
                    <strong>{{ data.item.leadInfoRes.merchantName }}</strong>
                  </p>
                  <p>{{ data.item.leadInfoRes.mobile | encryptPhone }}</p>
                  <p>{{ data.item.leadInfoRes.email }}</p>
                </div>
              </template>
              <template #cell(timeEstimate)="data">
                {{ data.item.startTime | formatDate('HH:mm DD/MM/YYYY') }} -
                {{ data.item.endTime | formatDate('HH:mm DD/MM/YYYY') }}
              </template>
              <template #cell(isPeriod)="data">
                {{ data.item.isPeriod | transformData(dataPeriod) }}
              </template>
              <template #cell(timeFinish)="data">
                {{ data.item.timeFinish | formatDate }}
              </template>
              <template #cell(sale)="data">
                <strong v-if="data.item.saleInfo">{{ data.item.saleInfo.name }}</strong>
                <br />
                <a href="#" class="color-1248EB" v-if="data.item.saleInfo">{{
                  data.item.saleInfo.userName
                }}</a>
              </template>
              <template #cell(createdDate)="data">
                {{ data.item.createdDate | formatDate('HH:mm DD/MM/YYYY') }}
              </template>
              <template #cell(operationType)="data">
                <span
                  v-if="data.item.operationType !== null && data.item.operationType"
                  class="badge"
                  :class="[data.item.operationType ? data.item.operationType : 'WAITING']"
                >
                  {{ data.item.operationType | transformData(Config.statusJob) }}
                </span>
                <p v-if="data.item.operationType === 'REJECT'">
                  Lý do từ chối: {{ data.item.rejectNote }}
                </p>
              </template>
              <template #cell(status)="data">
                <span v-if="data.item.isDeleted" class="badge badge-danger"> Hủy </span>
                <span v-else-if="data.item.outcome > 0" class="badge badge-primary">Đã xử lý</span>
                <span v-else class="badge badge-warning">Chưa xử lý</span>
              </template>
              <template #cell(action)="data">
                <b-dropdown class="text-center" variant="outline-light">
                  <b-dropdown-item>
                    <div
                      class="dropdown-item"
                      v-if="dataPermission.includes('CNPS_WKCLDR_GET_DETAIL_TASK_BY_ID')"
                      @click="detailCalendar(data.item.id)"
                    >
                      Chi tiết
                    </div>
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      dataPermission.includes('CNPS_WKCLDR_UPSERT_WKCLDR') &&
                      data.item.statusWkcldr === 'NOT_PROCESS'
                    "
                  >
                    <router-link class="dropdown-item" :to="`/update-work/${data.item.id}`"
                      >Cập nhật KQ
                    </router-link>
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      dataPermission.includes('CNPS_WKCLDR_UPSERT_WKCLDR') &&
                      data.item.statusWkcldr === 'NOT_PROCESS'
                    "
                  >
                    <router-link class="dropdown-item" :to="`/calendar-edit/${data.item.id}`"
                      >Sửa
                    </router-link>
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      dataPermission.includes('CNPS_WKCLDR_DELETE') &&
                      data.item.statusWkcldr === 'NOT_PROCESS'
                    "
                    class="dropdown-item"
                    @click="clickCancel(data.item)"
                    >Huỷ
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="pagination-bottom">
        <b-pagination
          v-model="search.pagination.page"
          :total-rows="totalRows"
          :per-page="search.pagination.size"
          class="mr-2 fl-right"
        ></b-pagination>
      </div>
    </div>

    <b-modal id="modal-noti" centered v-model="showNoti">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" />
        <h2 class="py-3 f18">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>

    <b-modal id="modal-noti" centered v-model="showAskBeforeAction">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" />
        <h2 class="py-3 f18">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="success" @click="acceptToAction()"> Đồng ý </b-button>
        <b-button size="sm" variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>

    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { CalendarService } from '@/services/calendar.service'
  import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
  import moment from 'moment'
  import { CommonService } from '@/services/common.service'
  import { mapGetters } from 'vuex'
  import { StaffService } from '@/services/staff.service'
  import Config from '@/thirdParty/config'
  const fieldTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'purposes', label: 'Mục đích/Hình thức' },
    { key: 'merchant', label: 'Merchant' },
    { key: 'timeEstimate', label: 'Thời gian dự kiến' },
    { key: 'depcription', label: 'Ghi chú' },
    { key: 'isPeriod', label: 'Độ ưu tiên' },
    { key: 'address', label: 'Điểm hẹn' },
    { key: 'resultDisplay', label: 'Kết quả' },
    { key: 'timeFinish', label: 'Thời gian hoàn thành' },
    { key: 'sale', label: 'Nhân viên xử lý' },
    { key: 'createdDate', label: 'Thời gian tạo' },
    { key: 'operationType', label: 'Trạng thái duyệt' },
    { key: 'status', label: 'Trạng thái' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    mixins: [prepareQueryParamsMixin],

    data() {
      return {
        Config,
        loading: true,
        fieldTable,
        filterTable: fieldTable,
        localeData: Config.localeData,
        dateRange: {
          startDate: null,
          endDate: null,
        },
        intendTimeRange: {
          startDate: null,
          endDate: null,
        },
        totalRows: null,
        totalOther: {},
        search: {
          pagination: {
            page: 1,
            size: 20,
          },
          userId: '',
        },
        dataConfigRegion: [],
        listUser: [],
        dataCalendar: [],
        dataProvince: [],
        dataConfigPurposes: [],
        purposesStatus: [],
        dataUser: JSON.parse(localStorage.getItem('userData')),
        optionOutcome: [
          { text: 'Tất cả', id: 'ALL' },
          { text: 'Chưa xử lý', id: 0 },
          { text: 'Đã xử lý', id: 1 },
          { text: 'Đã hủy', id: 2 },
        ],
        dataWorkType: Config.dataWorkType,
        dataLeadAction: Config.dataLeadAction,
        dataPeriod: Config.dataPeriod,
        showNoti: false,
        msgNoti: '',
        iconNoti: '',
        showAskBeforeAction: false,
        itemSelected: null,
        showLoading: false,
      }
    },

    created() {
      this.getDataSearch()
      this.configSystem()
      this.fetchData()
      this.getListStaffAndManager()
      this.getRegions()
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
        dataSearch: 'search/getDataSearchOther',
      }),
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          size: this.search.pagination.size,
          page: this.search.pagination.page,
        })
      },
    },

    methods: {
      async submitForm(event) {
        event.preventDefault()
        this.search.pagination.page = 1
        this.fetchData()

        this.$store.commit('search/SET_DATA_SEARCH_OTHER', {
          data: this.search,
          router: this.$router.currentRoute.path,
        })
      },

      async queryProvince(e) {
        try {
          const data = await StaffService.getProvinceRegion({ regionId: [e] })
          if (data.data.length > 0) {
            this.dataProvince = data.data.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            })
            this.dataProvince.unshift({ id: 'ALL', text: 'Tất cả' })
          }
        } catch (error) {}
      },

      async getListStaffAndManager() {
        try {
          const data = await StaffService.getStaffByIdSuperior({
            userId: this.dataUser.userId,
          })
          if (data.data.length > 0) {
            this.listUser = data.data.map(e => {
              return {
                id: e.userId,
                text: `${e.name} - ${e.userName}`,
              }
            })
            this.listUser.unshift({ id: 'ALL', text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },

      async getRegions() {
        const data = await StaffService.getRegions()
        if (data.data.length > 0) {
          this.dataConfigRegion = data.data.map(e => {
            return {
              id: e.id,
              text: e.name,
            }
          })
          this.dataConfigRegion.unshift({ id: 'ALL', text: 'Tất cả' })
        }
      },

      async exportExcel() {
        try {
          this.showLoading = true
          let data = null
          this.search.userId = this.dataUser.userId

          for (const key in this.search) {
            if (this.search[key] === 'ALL') delete this.search[key]
          }

          if (this.search.outcome === 2) {
            data = await CalendarService.exportExcel({
              ...this.search,
              ...{ isDeleted: true },
            })
          } else if (this.search.outcome === -1) {
            await CalendarService.exportExcel(this.search)
          } else {
            await CalendarService.exportExcel({
              ...this.search,
              ...{ isDeleted: false },
            })
          }
          if (data.success) {
            this.dataCalendar = data.data.content
            this.totalRows = data.data.totalWkcldrs
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },

      async fetchData() {
        this.loading = true
        try {
          let data = null
          this.search.userId = this.dataUser.userId
          this.search.outcome = this.search.outcome ? parseFloat(this.search.outcome) : -1

          for (const key in this.search) {
            if (this.search[key] === 'ALL') delete this.search[key]
          }

          if (this.search.outcome === 2) {
            data = await CalendarService.getCalendarByUser({
              ...this.search,
              ...{ isDeleted: true },
            })
          } else if (this.search.outcome === -1) {
            data = await CalendarService.getCalendarByUser(this.search)
          } else {
            data = await CalendarService.getCalendarByUser({
              ...this.search,
              ...{ isDeleted: false },
            })
          }
          if (data.success) {
            this.dataCalendar = data.data.content
            this.totalRows = data.data.totalWkcldrs
            this.totalOther = {
              totalLead: data.data.totalLead,
              totalMerchant: data.data.totalMerchant,
              totalPotential: data.data.totalPotential,
            }
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },

      configSystem() {
        return CommonService.getConfigSystem()
          .then(data => {
            if (data.success) {
              data.data.purposes.map(e => {
                this.dataConfigPurposes.push({ id: e.code, text: e.name })
                this.purposesStatus = [...this.purposesStatus, ...e.purposesStatus]
              })
              this.dataConfigPurposes.unshift({ id: 'ALL', text: 'Tất cả' })
            }
          })
          .catch(error => console.log(error))
      },

      transfromDate() {
        this.search.startTimeCreated = moment(this.dateRange.startDate).startOf('day').valueOf()
        this.search.endTimeCreated = moment(this.dateRange.endDate).endOf('day').valueOf()
      },

      transformIntendTime() {
        this.search.startTimeUTC = moment(this.intendTimeRange.startDate).startOf('day').valueOf()
        this.search.endTimeUTC = moment(this.intendTimeRange.endDate).endOf('day').valueOf()
      },

      async clearSearch() {
        this.search = {
          pagination: {
            page: 1,
            size: 20,
          },
          userId: '',
          outcome: -1,
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        this.intendTimeRange = {
          startDate: null,
          endDate: null,
        }
        this.dataProvince = []
        await this.fetchData()
      },

      getDataSearch() {
        if (JSON.stringify(this.dataSearch) === '{}') {
          this.search = {
            pagination: {
              page: 1,
              size: 20,
            },
            userId: this.dataUser.userId,
            outcome: -1,
          }
        } else {
          this.search = this.dataSearch
          this.dateRange.startDate = this.search.startTimeCreated
            ? new Date(this.search.startTimeCreated).toString()
            : null
          this.dateRange.endDate = this.search.endTimeCreated
            ? new Date(this.search.endTimeCreated).toString()
            : null
          this.intendTimeRange.startDate = this.search.startTimeUTC
            ? new Date(this.search.startTimeUTC).toString()
            : null
          this.intendTimeRange.endDate = this.search.endTimeUTC
            ? new Date(this.search.endTimeUTC).toString()
            : null
          if (this.search.regionId) this.queryProvince(this.search.regionId)
          this.fetchData()
        }
      },

      clickCancel(item) {
        this.itemSelected = item
        this.showAskBeforeAction = true
        this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
        this.msgNoti = 'Bạn có chắc chắn muốn huỷ công việc không ?'
      },

      acceptToAction() {
        if (this.itemSelected) this.cancelWork(this.itemSelected)
      },

      async cancelWork(item) {
        try {
          this.showLoading = true
          const response = await CalendarService.cancelWork({
            id: item.id,
          })
          if (response.code === 1000) {
            this.showNoti = true
            this.iconNoti = require('@/assets/img/noti-success2.svg')
            this.msgNoti = 'Huỷ công việc thành công!'
            await this.fetchData()
          } else {
            this.showNoti = true
            this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
            this.msgNoti = response.message
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
          this.showAskBeforeAction = false
        }
      },
      detailCalendar(id) {
        window.open(`/calendar/detail?id=${id}`, '_blank')
      },
    },
    watch: {
      'search.pagination.page': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
      },
      'search.pagination.size': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
      },
    },
  }
</script>

<style>
  body {
    font-family: 'Helvetica Neue Light', Helvetica, sans-serif;
    padding: 1em 2em 2em;
  }

  input,
  select {
    padding: 0.75em 0.5em;
    font-size: 100%;
    border: 1px solid #ccc;
    width: 100%;
  }

  select {
    height: 2.5em;
  }

  .example {
    background: #f2f2f2;
    border: 1px solid #ddd;
    padding: 0em 1em 1em;
    margin-bottom: 2em;
  }

  code,
  pre {
    margin: 1em 0;
    padding: 1em;
    border: 1px solid #bbb;
    display: block;
    background: #ddd;
    border-radius: 3px;
  }

  .settings {
    margin: 2em 0;
    border-top: 1px solid #bbb;
    background: #eee;
  }

  h5 {
    font-size: 100%;
    padding: 0;
  }

  .form-group {
    margin-bottom: 1em;
  }

  .form-group label {
    display: block;
  }
</style>
